import React, { useRef, useState, useCallback } from "react";
import Lottie from "lottie-react";
import "./SkillsStack.css";

const skillCards = [
  {
    title: "Web Development",
    description: "Modern web applications with React and responsive design",
    animation: "/WebsitePhotos/animations/React animation.json",
    idleMs: 1000,
  },
  {
    title: "Mobile Development",
    description: "Cross-platform mobile apps with React Native",
    animation: "/WebsitePhotos/animations/Coding.json",
  },
  {
    title: "Motion & 3D",
    description: "Dynamic animations and interactive 3D experiences",
    animation: "/WebsitePhotos/animations/3D design.json",
  },
  {
    title: "Realtime Backends",
    description: "Live data synchronization and real-time communication",
    animation: "/WebsitePhotos/animations/Gear.json",
  },
  {
    title: "Product Automation",
    description: "Automated workflows and continuous integration systems",
    animation: "/WebsitePhotos/animations/Automation.json",
    idleMs: 1000,
  },
  {
    title: "Graphic Design",
    description: "Visual identity and creative digital design",
    animation: "/WebsitePhotos/animations/GraphicDesign.json",
  },
  {
    title: "Cloud Computing",
    description: "Scalable infrastructure and cloud-based solutions",
    animation: "/WebsitePhotos/animations/Cloud.json",
    idleMs: 100,
  },
  {
    title: "AI Agents",
    description:
      "Building AI agents using Python, LangGraph and Vector Databases",
    animation: "/WebsitePhotos/animations/Robot.json",
    idleMs: 1000,
  },
];

const SkillCard = ({ card }) => {
  const lottieRef = useRef(null);
  const [animationData, setAnimationData] = useState(null);

  const setIdleFrame = useCallback(() => {
    if (lottieRef.current) {
      // Show the frame at the configured idle time (default ~2s)
      const idleTime = card.idleMs ?? 2000;
      lottieRef.current.goToAndStop(idleTime, false);
    }
  }, [card.idleMs]);

  // Load animation data
  React.useEffect(() => {
    fetch(card.animation)
      .then((response) => response.json())
      .then((data) => setAnimationData(data))
      .catch((err) => console.error("Failed to load animation:", err));
  }, [card.animation]);

  // Ensure we show the first frame as a static picture
  React.useEffect(() => {
    if (lottieRef.current && animationData) {
      lottieRef.current.stop();
      setIdleFrame();
    }
  }, [animationData, setIdleFrame]);

  const handleMouseEnter = () => {
    if (lottieRef.current) {
      lottieRef.current.goToAndStop(0, true);
      lottieRef.current.play();
    }
  };

  const handleMouseLeave = () => {
    if (lottieRef.current) {
      lottieRef.current.stop();
      setIdleFrame();
    }
  };

  return (
    <div
      className="skill-card"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {animationData && (
        <div className="skill-card__animation">
          <Lottie
            lottieRef={lottieRef}
            animationData={animationData}
            loop={true}
            autoplay={false}
          />
        </div>
      )}
      <h3>{card.title}</h3>
      <p>{card.description}</p>
    </div>
  );
};

function SkillsStack() {
  return (
    <section className="skills-stack-section scroll-fade-in">
      <div className="skills-container">
        {skillCards.map((card, index) => (
          <SkillCard key={index} card={card} />
        ))}
      </div>
    </section>
  );
}

export default SkillsStack;
